/* Klaviyo Newsletter Form mit Weglot Sprache */

// Übersetzungen je Sprache
const translations = {
    en: {
      label: "",
      placeholder: "Your email address",
      errorInvalidEmail: "Please enter a valid email.",
      errorSubmit: "An error occurred. Please try again later.",
      successRedirect: "https://lethalcosmetics.myshopify.com/pages/newsletter-check-inbox",
      buttonText: "Subscribe"
    },
    de: {
      label: "",
      placeholder: "Deine E-Mail-Adresse",
      errorInvalidEmail: "Bitte eine gültige E-Mail eingeben.",
      errorSubmit: "Technisches Problem. Bitte später erneut versuchen.",
      successRedirect: "https://lethalcosmetics.myshopify.com/de/pages/newsletter-check-inbox",
      buttonText: "Abonnieren"
    },
    fr: {
      label: "",
      placeholder: "Votre adresse e-mail",
      errorInvalidEmail: "Veuillez saisir une adresse email valide.",
      errorSubmit: "Problème technique. Veuillez réessayer plus tard.",
      successRedirect: "https://lethalcosmetics.myshopify.com/fr/pages/newsletter-check-inbox",
      buttonText: "S'abonner"
    }
  };
  
  // Formular-Texte setzen
  function setLanguageTexts() {
    const lang = (typeof Weglot !== 'undefined' && Weglot.getCurrentLang)
      ? Weglot.getCurrentLang()
      : 'en';
    const t = translations[lang] || translations.en;
  
    document.getElementById('emailLabel').textContent = t.label;
    document.getElementById('email').placeholder     = t.placeholder;
    document.getElementById('submitBtn').textContent = t.buttonText;
  }
  
  // Warte auf Weglot-Initialisierung und Sprachwechsel
  if (typeof Weglot !== 'undefined') {
    Weglot.on('initialized', () => {
      setLanguageTexts();
      console.log('Weglot initialisiert mit Sprache:', Weglot.getCurrentLang());
    });
    Weglot.on('languageChanged', newLang => {
      setLanguageTexts();
      console.log('Sprache gewechselt zu:', newLang);
    });
  } else {
    // Falls Weglot nicht verfügbar, setze Texte auf Englisch als Fallback
    setLanguageTexts();
  }
  
  // Formular-Handling
  const form     = document.getElementById('newsletterForm');
  const errorMsg = document.getElementById('errorMsg');
  
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    errorMsg.textContent = '';
  
    // Prüfe, ob Weglot geladen ist; fallback zu 'en'
    const lang  = (typeof Weglot !== 'undefined' && Weglot.getCurrentLang)
      ? Weglot.getCurrentLang() || 'en'
      : 'en';
    const t     = translations[lang] || translations.en;
  
    // E-Mail aus Formular holen
    const email = document.getElementById('email').value.trim();
  
    // Einfaches E-Mail-Format prüfen
    if (!email.match(/^\S+@\S+\.\S+$/)) {
      errorMsg.textContent = t.errorInvalidEmail;
      return;
    }
  
    console.log('Newsletter-Submit mit Sprache:', lang);
  
    try {
      // Sende Subscription zum Klaviyo-Subscribe-Endpunkt (nur email und List-ID)
      const response = await fetch(
        'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            'g':     'VP3cQu',    // <-- Ersetze mit deiner echten Klaviyo List-ID
            'email': email
            // 'language' nicht hier senden, da nicht unterstützt
          })
        }
      );
  
      const data = await response.json();
  
      if (data.success) {
        // Nach erfolgreicher Subscription separate Identify-Aufrufe für Profilfelder:
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {
          $email: email,
          language: lang   // Custom Field 'language' im Userprofil
        }]);
        window._learnq.push(['track', 'Newsletter Signup', {
          Language: lang
        }]);
  
        // Weiterleitung auf sprachspezifische Danke-Seite
        window.location.href = t.successRedirect;
      } else {
        errorMsg.textContent = data.message || t.errorSubmit;
      }
    } catch (err) {
      errorMsg.textContent = t.errorSubmit;
    }
  });
  /* EOF Klaviyo Newsletter Form */


  /* Localization pulldown */

  
(function () {
  var ROOT = document.documentElement;
  var ACTIVE = "kl-gift-active";
  function teaserVisible() {
    var el = document.querySelector('[class*="kl-teaser"]');
    if (!el) return false;
    var s = window.getComputedStyle(el);
    if (s.display === "none" || s.visibility === "hidden" || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function sync() {
    var on = teaserVisible();
    if (on && !ROOT.classList.contains(ACTIVE)) ROOT.classList.add(ACTIVE);
    else if (!on && ROOT.classList.contains(ACTIVE)) ROOT.classList.remove(ACTIVE);
  }
  sync();
  var mo = new MutationObserver(function () { sync(); });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style"] });
  [800, 2000, 4000, 8000].forEach(function (t) { setTimeout(sync, t); });
})();